export default {"src":"/_next/static/media/carousel-icon-04.65926a7d.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};